import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

interface AdminHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}

const AdminHeader = ({ title, description, actions }: AdminHeaderProps) => {
  return (
    <header className="sticky top-0 z-30 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-16 items-center justify-between px-6">
        <div className="min-w-0">
          <h1 className="text-lg font-semibold tracking-tight truncate">{title}</h1>
          {description && (
            <p className="text-sm text-muted-foreground truncate">{description}</p>
          )}
        </div>
        <div className="flex items-center gap-3 shrink-0">
          {actions}
          <Button variant="outline" size="sm" asChild>
            <Link to="/" target="_blank">
              <ExternalLink className="h-3.5 w-3.5 mr-1.5" />
              View Site
            </Link>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
